export const PAGE_SIZE = 25;

export const EMPTY_FILTER_QUERY = {
  state_in: [],
  institution_account_in: [],
  amount_gte: undefined,
  amount_lte: undefined,
  scheduled_date_before: undefined,
  scheduled_date_after: undefined,
  calendar_key: undefined,
  parent: undefined,
  frequency: [],
  selected_template_ids: [],
  selected_template_version_ids: [],
};
